import React, { useState } from "react";
import {
  SafeAreaView,
  ScrollView,
  View,
  Text,
  Image,
  TouchableOpacity,
  StyleSheet,
} from "react-native";
import AppColors from "../../Constants/AppColors";
import AppFonts from "../../Constants/AppFonts";
import AppImages from "../../Constants/AppImages";
import useAppNavigation from "../../Routes/useAppNavigation";

/**
 * MyProfile (mobile view) — mirrors the production /MyProfile page
 * (Account/MyProfile.js): profile image + Edit/Change Password menu,
 * Contact Information card and General Information card.
 */
const Field = ({ label, value, full }) => (
  <View style={[styles.field, full && { width: "100%" }]}>
    <Text style={styles.fieldLabel}>{label}</Text>
    <Text style={styles.fieldValue}>{value}</Text>
  </View>
);

const MyProfile = () => {
  const navigation = useAppNavigation();
  const [menu, setMenu] = useState(false);

  return (
    <SafeAreaView style={styles.safe}>
      {/* Header */}
      <View style={styles.header}>
        <View style={styles.row}>
          <TouchableOpacity onPress={() => navigation.goBack()}>
            <Image source={AppImages.Backbtn} style={styles.backIcon} resizeMode="contain" />
          </TouchableOpacity>
          <Text style={styles.headerTitle}>My Profile</Text>
        </View>
        <TouchableOpacity onPress={() => setMenu((m) => !m)}>
          <Image source={AppImages.Threedots} style={styles.dots} resizeMode="contain" />
        </TouchableOpacity>
      </View>

      {/* Edit / Change Password menu */}
      {menu && (
        <View style={styles.menu}>
          <TouchableOpacity
            style={styles.menuItem}
            onPress={() => {
              setMenu(false);
              navigation.navigate("EditProfile");
            }}
          >
            <Text style={styles.menuText}>Edit</Text>
          </TouchableOpacity>
          <View style={styles.menuDivider} />
          <TouchableOpacity
            style={styles.menuItem}
            onPress={() => {
              setMenu(false);
              navigation.navigate("ChangePasswordProfile");
            }}
          >
            <Text style={styles.menuText}>Change Password</Text>
          </TouchableOpacity>
        </View>
      )}

      <ScrollView showsVerticalScrollIndicator={false}>
        {/* Profile image */}
        <View style={styles.profileWrap}>
          <Image source={AppImages.profilePic} style={styles.profileImg} resizeMode="cover" />
          <Text style={styles.profileName}>Mark Woods</Text>
        </View>

        {/* Contact Information */}
        <View style={styles.card}>
          <Text style={styles.cardHeading}>Contact Information</Text>
          <View style={styles.fieldGrid}>
            <Field label="Name" value="Mark Woods" />
            <Field label="Contact Number" value="99999 99999" />
            <Field label="Email" value="markwoods@gmail.com" full />
          </View>
        </View>

        {/* General Information */}
        <View style={styles.card}>
          <Text style={styles.cardHeading}>General Information</Text>
          <View style={styles.fieldGrid}>
            <Field
              label="Address"
              value="100, Vishrantwadi, Kalas, Pune- 411005"
              full
            />
            <Field label="City" value="Pune" />
            <Field label="Nationality" value="India" />
            <Field label="Date Of Birth" value="17-08-1989" />
            <Field label="Joining Date" value="08-10-2022" />
            <Field label="Gender" value="Male" />
            <Field label="Internal No." value="123456" />
          </View>
        </View>
        <View style={{ height: 30 }} />
      </ScrollView>
    </SafeAreaView>
  );
};

export default MyProfile;

const styles = StyleSheet.create({
  safe: { flex: 1, backgroundColor: AppColors.white },
  header: {
    width: "100%",
    height: 58,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    paddingHorizontal: 20,
    backgroundColor: AppColors.white,
    shadowColor: "#9C4900",
    shadowOffset: { width: 0, height: 3 },
    shadowOpacity: 1,
    shadowRadius: 10,
    elevation: 6,
  },
  row: { flexDirection: "row", alignItems: "center" },
  backIcon: { width: 8, height: 15 },
  headerTitle: {
    color: AppColors.brown1,
    fontSize: 16,
    fontFamily: AppFonts.OverpassMedium,
    marginLeft: 20,
  },
  dots: { width: 16, height: 17 },
  menu: {
    position: "absolute",
    top: 56,
    right: 16,
    backgroundColor: AppColors.white,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: "#9C49001A",
    paddingVertical: 4,
    zIndex: 10,
    elevation: 8,
    shadowColor: "#9C4900",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.5,
    shadowRadius: 8,
    minWidth: 150,
  },
  menuItem: { paddingVertical: 10, paddingHorizontal: 16 },
  menuText: { color: AppColors.brown1, fontSize: 14, fontFamily: AppFonts.OverpassRegular },
  menuDivider: { height: 1, backgroundColor: "#9C49001A" },
  profileWrap: { alignItems: "center", marginTop: 24, marginBottom: 8 },
  profileImg: {
    width: 90,
    height: 90,
    borderRadius: 45,
    backgroundColor: AppColors.sandal,
  },
  profileName: {
    marginTop: 12,
    color: AppColors.brown1,
    fontSize: 18,
    fontFamily: AppFonts.OverpassBold,
  },
  card: {
    backgroundColor: AppColors.white,
    borderWidth: 1,
    borderColor: "#9C49001A",
    borderRadius: 10,
    marginHorizontal: 20,
    marginTop: 16,
    padding: 16,
  },
  cardHeading: {
    color: AppColors.brown1,
    fontSize: 16,
    fontFamily: AppFonts.OverpassBold,
    marginBottom: 6,
  },
  fieldGrid: {
    flexDirection: "row",
    flexWrap: "wrap",
  },
  field: { width: "50%", marginTop: 14 },
  fieldLabel: {
    color: AppColors.dualbrown,
    fontSize: 12,
    fontFamily: AppFonts.OverpassRegular,
    marginBottom: 3,
  },
  fieldValue: {
    color: AppColors.brown1,
    fontSize: 14,
    fontFamily: AppFonts.OverpassSemiBold,
  },
});
